module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('div', [_c('div', [_c('b-button', {
    class: _vm.visible ? null : 'collapsed',
    attrs: {
      "variant": "outline-dark",
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v("\n                Filters")]), _vm._v(" "), (_vm.veiwVehicleBookingForm.length > 0) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('FF_EXPORT')
      }
    }
  }, [_vm._v("Export as Excel")]) : _vm._e(), _vm._v(" "), (_vm.veiwVehicleBookingForm.length > 0) ? _c('b-button', {
    staticClass: "pull-right mr-2",
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('FF_EXPORT_CONTAINERWISE')
      }
    }
  }, [_vm._v("Export ContainerWise Report")]) : _vm._e()], 1), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-card', {
    staticClass: "mt-2"
  }, [_c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('date-range-picker', {
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": function($event) {
        _vm.viewAssignment('0', '1', '1');
      }
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 row justify-content-center"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search\n                  ")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted pull-right"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-2"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.veiwVehicleBookingForm,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "ffExportFclId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "ffExportFclSeries",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.ffExportFclSeries)), _c('br')]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("moment")(row1.item.loginTime))), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Enquiry No." + _vm._s(row1.item.mainEnquirySeries))])]
      }
    }, {
      key: "placeRecp",
      fn: function(row21) {
        return [_c('b', [_vm._v("Type : " + _vm._s(row21.item.transportType))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Stuffing Type : " + _vm._s(row21.item.stuffingType))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Shipping Line : " + _vm._s(row21.item.shippingLine))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("POR Location : " + _vm._s(row21.item.placeRecp))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Load Port Location : " + _vm._s(row21.item.LoadPort))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("POD Location : " + _vm._s(row21.item.placeDis))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("FPOD : " + _vm._s(row21.item.finalPlace))])]
      }
    }, {
      key: "freightContainers",
      fn: function(row3) {
        return [(row3.item.freightContainers != null) ? _c('div', _vm._l((row3.item.freightContainers.split(',')), function(item, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item + " "))])], 1)])
        })) : _vm._e()]
      }
    }, {
      key: "freightContainersType",
      fn: function(row2) {
        return [(row2.item.freightContainersType != null) ? _c('div', _vm._l((row2.item.freightContainersType.split(',')), function(item1, index) {
          return _c('div', {
            key: index
          }, [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1))])], 1)
        })) : _vm._e()]
      }
    }, {
      key: "shippingBillNo",
      fn: function(row5) {
        return [(row5.item.shippingBillNo != null) ? _c('div', _vm._l((row5.item.shippingBillNo.split(',')), function(item1, index) {
          return _c('div', {
            key: index
          }, [_c('span', [_vm._v(" " + _vm._s(item1))])])
        })) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "20",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16a17be6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/reports/freightReports.vue
// module id = 2414
// module chunks = 0